<template>
    <div class="border rounded-xl shadow-md bg-primary transition-transform transform hover:scale-105 cursor-pointer">
        <slot></slot>
    </div>
</template>
<script>
</script>